"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  loginHeaderPadding: '14px 14px 0px 14px',
  maintenanceFooterDisplay: 'none',
  menuBarHeight: 56,
  navBarActiveUnderline: 2,
  navBarSubtitleVisibility: 'visible',
  navBarOrgFontSize: 10,
  navBarOrgFontStyle: 'normal',
  navBarOrgFontWeight: 'normal',
  navBarUserFontSize: 14,
  navBarUserFontStyle: 'normal',
  navBarUserFontWeight: 'normal',
  productNameDisplay: 'flex',
  sideBarVisibility: 'hidden',
  sideBarWidth: 0
};
exports.default = _default;